import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";

const blogCol = collection(db, "blog");

export const slugify = (s) =>
  (s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80);

export const subscribeBlog = (cb) =>
  onSnapshot(query(blogCol, orderBy("date", "desc")), (snap) =>
    cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  );

export const createPost = async ({ id, title, category, excerpt, content, readTime, date, status }) => {
  const ref = doc(db, "blog", id);
  await setDoc(ref, {
    title,
    category: category || "",
    excerpt: excerpt || "",
    content: content || "",
    readTime: readTime || "",
    status: status === "live" ? "live" : "draft",
    date: date ? Timestamp.fromDate(new Date(date)) : serverTimestamp(),
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
};

export const setPostStatus = (id, status) =>
  updateDoc(doc(db, "blog", id), {
    status: status === "live" ? "live" : "draft",
    updatedAt: serverTimestamp(),
  });

export const updatePost = (id, patch) => {
  const body = { ...patch, updatedAt: serverTimestamp() };
  if (patch.date && typeof patch.date === "string") {
    body.date = Timestamp.fromDate(new Date(patch.date));
  }
  return updateDoc(doc(db, "blog", id), body);
};

export const deletePost = (id) => deleteDoc(doc(db, "blog", id));

export const toDateInput = (d) => {
  if (!d) return "";
  const date = d.toDate ? d.toDate() : new Date(d);
  if (isNaN(date)) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
